import { Link, Navigate, useLocation } from 'react-router-dom';
import { useCapabilities } from '../admin/CapabilityProvider';

// Browser-route compatibility only. The shared /admin/tax-review API is still active.
export default function LegacyTaxReviewRedirect() {
  const { search, hash } = useLocation();
  const { has } = useCapabilities();
  if (has('admin:modules:read')) {
    return <Navigate replace to={{ pathname: '/modules/tax-review', search, hash }} />;
  }
  return (
    <section className="admin-page" style={{ maxWidth: 800, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1>Tax Review has moved</h1>
      <p>Tax review is now part of Monthly Tax Submissions.</p>
      <p>Your account needs access to that workspace. Contact your administrator.</p>
      <Link to="/admin">Back to Command Center</Link>
    </section>
  );
}
